import { ClientRequestBase } from "./client_request_base.js";

export type S2SConsentSnapshot = {
  id: string;
  region: string;
  att_status: string;
  analytics_allowed: boolean;
  ad_measurement_allowed: boolean;
  ad_personalization_allowed: boolean;
  timestamp: string;
  policy_version: string;
};

export type S2SIdentifiers = {
  appsflyer_id?: string;
  gaid?: string;
  idfa?: string;
  idfv?: string;
  gclid?: string;
  market_referrer_gclid?: string;
  gbraid?: string;
};

export type S2SEventEnvelope = {
  payload: Record<string, unknown>;
  event_id: string;
  event_time: string;
  first_open_time: string;
  schema_version: string;
  app_id: string;
  app_version: string;
  platform: string;
  locale: string;
  device: string;
  session_id: string;
  sdk_version: string;
  consent: S2SConsentSnapshot;
  identifiers: S2SIdentifiers;
  os_version?: string;
  os_build?: string;
  revenue?: number;
  currency?: string;
  transaction_id?: string;
};

export class CustomEventRequest extends ClientRequestBase
{
  public readonly event_id?: string;
  public readonly event_time?: string;
  public readonly first_open_time?: string;
  public readonly schema_version?: string;
  public readonly app_id?: string;
  public readonly app_version?: string;
  public readonly platform?: string;
  public readonly locale?: string;
  public readonly device?: string;
  public readonly session_id?: string;
  public readonly sdk_version?: string;
  public readonly consent?: S2SConsentSnapshot;
  public readonly identifiers?: S2SIdentifiers;
  public readonly os_version?: string;
  public readonly os_build?: string;
  public readonly revenue?: number;
  public readonly currency?: string;
  public readonly transaction_id?: string;

  constructor(
    public readonly payload: Record<string, unknown>,
    envelope?: S2SEventEnvelope,
  )
  {
    super();

    if ( !envelope ) return;

    this.event_id = envelope.event_id;
    this.event_time = envelope.event_time;
    this.first_open_time = envelope.first_open_time;
    this.schema_version = envelope.schema_version;
    this.app_id = envelope.app_id;
    this.app_version = envelope.app_version;
    this.platform = envelope.platform;
    this.locale = envelope.locale;
    this.device = envelope.device;
    this.session_id = envelope.session_id;
    this.sdk_version = envelope.sdk_version;
    this.consent = envelope.consent;
    this.identifiers = envelope.identifiers;
    this.os_version = envelope.os_version;
    this.os_build = envelope.os_build;
    this.revenue = envelope.revenue;
    this.currency = envelope.currency;
    this.transaction_id = envelope.transaction_id;
  }
}
